export enum vehicleClassesConstants {
  GET_VEHICLE_CLASSES = 'GET_VEHICLE_CLASSES',
  GET_VEHICLE_CLASS = 'GET_VEHICLE_CLASS',
  ADD_VEHICLE_CLASS = 'ADD_VEHICLE_CLASS',
  EDIT_VEHICLE_CLASS = 'EDIT_VEHICLE_CLASS',
  DELETE_VEHICLE_CLASS = 'DELETE_VEHICLE_CLASS',
}
